import React from "react";
import { Typography } from "@mui/material";
import { HasClassName } from "@lib/types";
import { makeStyles } from "@providers/Mui";
import clsx from "clsx";

type H4Props = HasClassName & {};

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 21,
    fontWeight: 700,
  },
}));

export const H4: React.FC<H4Props> = ({ children, className }) => {
  const classes = useStyles();
  return (
    <Typography className={clsx(classes.root, className)}>
      {children}
    </Typography>
  );
};
